import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify';
import firebase from 'firebase/app';
import 'firebase/firestore';

Vue.prototype.$firebase = firebase;

const firebaseConfig = {
  apiKey: "AIzaSyCP6yMrCtDWNbMgUwdLyeO3BDRAJwGCNYk",
  authDomain: "silent-auction-vacations.firebaseapp.com",
  databaseURL: "https://silent-auction-vacations.firebaseio.com",
  projectId: "silent-auction-vacations",
  storageBucket: "silent-auction-vacations.appspot.com",
  messagingSenderId: "1044426753281",
  appId: "1:1044426753281:web:e5b5d7434f28e773c60700"
};

if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
}

Vue.config.productionTip = false

new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
